<template>
    <div class="container-formulario">
        <div class="d-lg-flex flex-collum coluna-1">
            <div class="flex-shrink-1">
                <img src="../../assets/LogoEvento.png" class="rounded evento " title="Grupo Negócios Públicos">
            </div>
            <div class="flex-lg-fill">
                <div class="card painel">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-3 col-lg-4">
                                <span class="titulo">Evento</span>
                                <h4 class="texto-1">19°CONGRESSO BRASILEIRO DE PREGOEIROS E AGENTES DE CONTRATAÇÃO</h4>
                            </div>
                            <div class="col-sm-3 col-lg-3">
                                <span class="titulo">Data &amp; Local</span>
                                <h4 class="texto-1">18 A 21 DE MARÇO DE 2024</h4>
                                <h4 class="texto-1">FOZ DO IGUAÇU-PR</h4>
                            </div>
                            <div class="col-sm-3 col-lg-3">
                                <span class="titulo">Participante</span>
                                <h4 class="texto-1">Daniel Araujo Batista</h4>
                            </div>
                            <div class="col-sm-3 col-lg-2">
                                <img src="../../assets/img/logo_np.png" class="logo mt-1" title="Grupo Negócios Públicos">
                                <span class="titulo">Passaporte</span>
                                <h4 class="texto-1">IQP699</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-fill">
            <!--<Selecao />-->
            <Confirmado />
        </div>
        </div>
    </template>

    <script>

        /*import Selecao from "@/views/Oficina/Etapas/Selecao.vue";*/
        import Confirmado from "@/views/Oficina/Etapas/Confirmado.vue";

        export default {
            name: "Oficina",
            components: {
                /*Selecao,*/
                Confirmado
            },
            data() {
                return {

                }
            },
            methods: {

            },
            mounted() {

            },
            updated() { },

            watch: {

            },
        };
    </script>

    <style scoped lang="scss">

        .container-formulario {
            overflow-y: auto;
            max-height: calc(100vh - 0rem);
            height: calc(100vh - 0rem);
            background-color: #fff;
            padding: 0;
        }

        .coluna-1 {
            margin: 30px ;
            margin-bottom: 0;
        }

        @media (min-width: 680px) {
            .coluna-1 {
                margin: 60px;
                margin-top: 30px !important;
                margin-bottom: 0;
            }
        }

        @media (min-width: 992px) {
            .coluna-1 {
                margin: 30px;
                margin-top: 30px !important;
                margin-bottom: 0;
            }
        }

        .titulo {
            font-size: 14px;
            color: #bd2344;
            font-weight: 600;
        }

        .texto-1 {
            font-size: 16px;
            line-height: 26px;
            color: #7a7a7a;
            margin: 0px;
            font-weight: 500;
        }

        .logo {
            height: 34px;
            margin-bottom: 0px;
            margin-left: 10px;
            margin-right: 10px;
            float: right;
        }

        .evento {
            margin-bottom: 30px;
            height: 140px;
            width: 100%;
        }

        @media (min-width: 380px) {
            .evento {
                margin-bottom: 30px;
                height: auto;
                width: 100%;
            }
        }

        @media (min-width: 700px) {
            .evento {
                margin-bottom: 30px;
                height: auto;
                width: 100%;
            }
        }

        @media (min-width: 992px) {
            .evento {
                margin-bottom: 30px;
                height: auto;
                width: 280px;
            }
        }

        .painel {
            height: 80%;
            width: 100%;
        }

        @media (min-width: 992px) {
            .painel {
                height: 83%;
                margin-left: 30px;
                width: 98%;
                margin-right: 30px;
            }
        }

    </style>
